"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileModal = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _baseReactComponents = require("@navinc/base-react-components");

var _jsxRuntime = require("react/jsx-runtime");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ApplyButton = (0, _styledComponents["default"])(_baseReactComponents.Button).withConfig({
  displayName: "ApplyButton",
  componentId: "sc-1rmnrn7-0"
})(["@media screen and (", "){&&{display:none;}}"], function (_ref) {
  var forLargerThanPhone = _ref.theme.forLargerThanPhone;
  return forLargerThanPhone;
});
var CloseButton = (0, _styledComponents["default"])(_baseReactComponents.Copy).withConfig({
  displayName: "CloseButton",
  componentId: "sc-1rmnrn7-1"
})(["cursor:pointer;@media screen and (", "){&&{display:none;}}"], function (_ref2) {
  var forLargerThanPhone = _ref2.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var Header = _styledComponents["default"].div.withConfig({
  displayName: "Header",
  componentId: "sc-1rmnrn7-2"
})(["display:flex;flex-direction:row;align-items:flex-start;justify-content:flex-end;padding:16px 24px;@media screen and (", "){display:none;}"], function (_ref3) {
  var forLargerThanPhone = _ref3.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var Footer = _styledComponents["default"].div.withConfig({
  displayName: "Footer",
  componentId: "sc-1rmnrn7-3"
})(["display:flex;flex-direction:row;align-items:center;justify-content:center;padding:16px 24px 64px 24px;@media screen and (", "){display:none;}"], function (_ref4) {
  var forLargerThanPhone = _ref4.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var Viewport = _styledComponents["default"].div.withConfig({
  displayName: "Viewport",
  componentId: "sc-1rmnrn7-4"
})(["display:block;overflow:auto;padding:16px 32px;@media screen and (", "){padding:0;}"], function (_ref5) {
  var forLargerThanPhone = _ref5.theme.forLargerThanPhone;
  return forLargerThanPhone;
});

var Modal = _styledComponents["default"].div.withConfig({
  displayName: "Modal",
  componentId: "sc-1rmnrn7-5"
})(["display:", ";flex-direction:column;align-items:stretch;justify-content:flex-start;background-color:", ";position:fixed;top:0;right:0;bottom:0;left:0;width:100%;height:100%;z-index:1000;@media screen and (", "){display:block;position:relative;height:auto;background-color:initial;}& > ", ",& > ", "{flex:0 0 auto;}& > ", "{flex:1 0 0;}"], function (_ref6) {
  var open = _ref6.open;
  return open ? 'flex' : 'none';
}, function (_ref7) {
  var belugaWhite = _ref7.theme.belugaWhite;
  return belugaWhite;
}, function (_ref8) {
  var forLargerThanPhone = _ref8.theme.forLargerThanPhone;
  return forLargerThanPhone;
}, Header, Footer, Viewport);

var MobileModalComponent = function MobileModalComponent(_ref9) {
  var _ref9$open = _ref9.open,
      open = _ref9$open === void 0 ? false : _ref9$open,
      _ref9$onComplete = _ref9.onComplete,
      onComplete = _ref9$onComplete === void 0 ? function () {} : _ref9$onComplete,
      closeLabel = _ref9.closeLabel,
      _ref9$completionLabel = _ref9.completionLabel,
      completionLabel = _ref9$completionLabel === void 0 ? 'Apply Filters' : _ref9$completionLabel,
      className = _ref9.className,
      children = _ref9.children,
      theme = _ref9.theme;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Modal, {
    open: open,
    className: className,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(Header, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(CloseButton, {
        size: "lg",
        bold: true,
        onClick: function onClick() {
          return onComplete();
        },
        children: closeLabel !== null && closeLabel !== void 0 ? closeLabel : /*#__PURE__*/(0, _jsxRuntime.jsx)(_baseReactComponents.Icon, {
          name: "actions/close",
          color: theme.scuttleGray600,
          height: "24",
          width: "24"
        })
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Viewport, {
      children: children
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(Footer, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(ApplyButton, {
        size: "large",
        variation: "outline",
        onClick: function onClick() {
          return onComplete();
        },
        children: completionLabel
      })
    })]
  });
};

var MobileModal = (0, _styledComponents["default"])((0, _styledComponents.withTheme)(MobileModalComponent)).withConfig({
  displayName: "MobileModal",
  componentId: "sc-1rmnrn7-6"
})([""]);
exports.MobileModal = MobileModal;
MobileModal.displayName = 'MobileModal';
//# sourceMappingURL=mobile-modal.js.map